import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "c9251676-b158-4c9b-99e9-415fc86ca001", // This is the ONLY mandatory field that you need to supply.
        authority: process.env.REACT_APP_AZURE_AUTHORITY || "https://login.microsoftonline.com/02a07ecd-3b93-4654-9894-731812d054c8", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000", // You must register this URI on Azure Portal/App Registration.
        postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || "http://localhost:3000", // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                    case LogLevel.Info:
                    case LogLevel.Verbose:
                    case LogLevel.Warning:
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["openid", "profile", "email"]
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

/**
 * Company domain validation - only allow users from specific domain(s)
 */
export const allowedDomains = process.env.REACT_APP_ALLOWED_DOMAINS
    ? process.env.REACT_APP_ALLOWED_DOMAINS.split(',').map(domain => domain.trim())
    : ['photonicscience.com', 'tibidaboscientific.com', 'scintacor.com', 'pxinc.com']; // Replace with your company domain

/**
 * Validate if user email belongs to allowed company domain
 */
export const isValidCompanyUser = (email) => {
    if (!email) return false;
    
    const normalizedEmail = email.toLowerCase();
    const emailDomain = normalizedEmail.split('@')[1];
    return allowedDomains.some(domain => emailDomain === domain.toLowerCase());
};